module.exports = __webpack_public_path__ + "static/media/crabappleBlossoms.0bfaa6cc.jpg";